import { render, staticRenderFns } from "./WalletRecordList.vue?vue&type=template&id=3c6aaa24&scoped=true"
import script from "./WalletRecordList.vue?vue&type=script&lang=js"
export * from "./WalletRecordList.vue?vue&type=script&lang=js"
import style0 from "./WalletRecordList.vue?vue&type=style&index=0&id=3c6aaa24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6aaa24",
  null
  
)

export default component.exports